import React, { useEffect, useState } from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const APP_STORE_URL = 'https://apps.apple.com/app/id6755252485';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=co.gamegarden.block';

const detectStoreUrl = (): string | null => {
  const userAgent = navigator.userAgent;
  // iPadOS reports a desktop Mac user agent, so also check for touch support
  const isIOS = /iPhone|iPad|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) {
    return APP_STORE_URL;
  }
  if (/Android/.test(userAgent)) {
    return PLAY_STORE_URL;
  }
  return null;
};

const BlockStoreRedirect: React.FC = () => {
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    const storeUrl = detectStoreUrl();
    if (storeUrl) {
      window.location.replace(storeUrl);
    } else {
      setRedirecting(false);
    }
  }, []);

  if (redirecting) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)'
        }}
      >
        <Text style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
          Opening store…
        </Text>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%)',
        padding: '20px'
      }}
    >
      <Card
        className="glass-effect"
        style={{
          width: '100%',
          maxWidth: '480px',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-xl)',
          border: '1px solid var(--border-color)',
          background: 'rgba(30, 41, 59, 0.9)',
          backdropFilter: 'blur(20px)'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} className="text-gradient" style={{ margin: 0, marginBottom: 8 }}>
            Block Drop Puzzle Blast
          </Title>
          <Text style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
            Get the game on your phone
          </Text>
        </div>

        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Button
            type="primary"
            size="large"
            icon={<AppleOutlined />}
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            block
            style={{ height: 48, fontSize: '1rem' }}
          >
            Download on the App Store
          </Button>
          <Button
            type="primary"
            size="large"
            icon={<AndroidOutlined />}
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            block
            style={{ height: 48, fontSize: '1rem' }}
          >
            Get it on Google Play
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default BlockStoreRedirect;
